module.exports = __webpack_public_path__ + "img/11_noff_close_L3.c0ac0cf8.svg";